<template>
    <div class="w-11/12 mx-auto">
        <div class="w-full">
            <label for="search" class="sr-only">Search</label>
            <form form class="relative w-full" @submit.prevent="searchEntities">
                <div class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                    </svg>
                </div>
                <input
                    id="search"
                    v-model="searchInput"
                    name="search"
                    class="
                        block
                        w-full
                        bg-white
                        rounded-md
                        py-2
                        pl-10
                        pr-3
                        text-sm
                        focus:ring-0
                        border-gray-300
                        focus:text-gray-900
                        sm:text-sm
                    "
                    placeholder="Search"
                    type="search"
                />
            </form>
        </div>
        <div class="w-full mt-2 flex flex-col max-h-64 h-64 overflow-y-scroll">
            <div v-if="loading" class="w-full flex justify-center py-6">
                <svg class="animate-spin h-8 w-8 mr-3" viewBox="0 0 512 512">
                    <path
                        fill="currentColor"
                        d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z"
                        class=""
                    ></path>
                </svg>
            </div>
            <div class="">
                <div v-if="searchResult.length && !loading">
                    <p class="text-sm text-gray-800 mx-2">{{ resultCount }} resultaten</p>
                </div>
                <div v-if="searchResult.length && !loading" class="">
                    <div
                        v-for="result in searchResult"
                        :key="result.id"
                        :class="[
                            selectedEventsId.includes(result.id) ? active : 'bg-gray-100',
                            'text-sm my-1 p-4 rounded cursor-pointer hover:bg-gray-300 flex justify-between',
                        ]"
                        @click="selectEvent(result)"
                    >
                        <div class="">
                            <h5 class="text-gray-800">{{ result.entity }}</h5>
                            <p class="text-gray-800">{{ result.check }}</p>
                        </div>
                        <div class="flex flex-row">
                            <p class="text-gray-800 my-auto mx2">{{ result.state }}</p>
                            <div class="h-3 w-3 rounded-full mx-2 my-auto" :class="stateColors[result.status]"></div>
                        </div>
                    </div>
                </div>
                <div v-if="events && !searchResult.length && !searchInput" class="">
                    <div
                        v-for="event in events"
                        :key="event.id"
                        :class="[
                            selectedEventsId.includes(event.id) ? active : 'bg-gray-100',
                            'text-sm my-1 p-4 rounded cursor-pointer hover:bg-gray-300 flex justify-between',
                        ]"
                        @click="selectEvent(event)"
                    >
                        <div class="">
                            <h5 class="text-gray-800">{{ event.entity }}</h5>
                            <p class="text-gray-800">{{ event.check }}</p>
                        </div>
                        <div class="flex flex-row">
                            <p class="text-gray-800 my-auto mx2">{{ event.state }}</p>
                            <div class="h-3 w-3 rounded-full mx-2 my-auto" :class="stateColors[event.status]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, ref } from "vue";

export default {
    name: "CreateSensuIntergration",
    props: {
        preSelectedEvents: {
            type: Array,
            required: true,
        },
    },
    emits: ["sensu-project-check"],
    setup(props, { emit }) {
        const events = ref([]);
        const searchResult = ref([]);
        const selectedEventsId = ref([]);
        const searchInput = ref(null);
        const loading = ref(false);
        const active = "bg-lightblue-200";
        const pain = ref(null);
        const stateColors = ref(["bg-green-500", "bg-yellow-500", "bg-red-500"]);

        props.preSelectedEvents.forEach((preSelectedEvent) => {
            if (!preSelectedEvent.id) {
                preSelectedEvent.id = preSelectedEvent.checkable_references;
            }
            selectedEventsId.value.push(preSelectedEvent.id);
        });

        const setEvents = () => {
            loading.value = true;
            axios
                .get(route("sensu.events"))
                .then((res) => (events.value = res.data))
                .finally(() => (loading.value = false));
        };

        const selectedEvents = computed(() => {
            const selectedEventsIdNoDupes = ref(
                selectedEventsId.value.filter((event, index) => selectedEventsId.value.indexOf(event) === index)
            );
            return selectedEventsIdNoDupes.value.map((eventId) => events.value.find((event) => event.id === eventId));
        });

        const searchEntities = () => {
            if (!searchInput.value) {
                setEvents();
                return;
            }
            loading.value = true;
            axios
                .get(route("sensu.entities.events", searchInput.value))
                .then((res) => (searchResult.value = res.data))
                .finally(() => (loading.value = false));
        };

        const selectEvent = (event) => {
            if (selectedEventsId.value.includes(event.id)) {
                while (selectedEventsId.value.includes(event.id)) {
                    selectedEventsId.value.splice(selectedEventsId.value.indexOf(event.id), 1);
                }
            } else {
                selectedEventsId.value.push(event.id);
            }
            emit("sensu-project-check", selectedEvents);
        };

        const resultCount = computed(() => searchResult.value.length);

        setEvents();

        return {
            events,
            searchResult,
            searchInput,
            searchEntities,
            selectEvent,
            resultCount,
            loading,
            selectedEvents,
            active,
            pain,
            stateColors,
            selectedEventsId,
        };
    },
};
</script>
